import Api from "./Api";
import { API_VERSION } from "@/config/index";

export default {
  GetAllMoviesByDate(payload) {
    return Api().get(
      `/${API_VERSION}/webapp/session/${payload.movie_code}/${payload.date}`
    );
  },
  GetSeatLayout(payload) {
    return Api().get(
      `/${API_VERSION}/webapp/seat_layout/${payload.session_id}/${payload.cinema_code}`
    );
  }
};



// WEBPACK FOOTER //
// ./src/apiServices/SessionService.js